import { DockConfiguration } from '../configuration';

export const addMicrofrontendsToImportMaps = (
  microfrontends: DockConfiguration['microfrontends'],
) => {
  const importMaps: Record<string, string> = microfrontends.reduce(
    (previousValue, currentValue) => ({
      ...previousValue,
      [currentValue.id]: currentValue.url,
    }),
    {},
  );
  return System.addImportMap({ imports: importMaps });
};
